import React from 'react'

export function AreaTitle({ title }) {
  return <h3 className="mb-4 uppercase text-red-400 text-lg">{title}</h3>
}
